import { tiendasApi } from '../api'

export const authApiSlice = tiendasApi.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({
            query: ({ email, contrasena }) => ({
                url: 'self/login',
                method: 'POST',
                body: { email, contrasena }
            })
        }),
        refreshToken: builder.mutation({
            query: token => ({
                url: 'self/refresh-token',
                method: 'GET',
                headers: {
                    'Authorization': token,
                },
            })
        }),
        getTokenForApp: builder.mutation({
            query: idCliente => ({
                url: 'self/token-for-app/' + idCliente,
                method: 'GET',
            })
        }),
        getSidebarData: builder.mutation({
            query: token => ({
                url: 'self/sidebar',
                method: 'GET',
                headers: {
                    'Authorization': token,
                },
            })
        }),
    })
})

export const {
    useLoginMutation,
    useRefreshTokenMutation,
    useGetTokenForAppMutation,
    useGetSidebarDataMutation,
} = authApiSlice